import {ValueObject} from '@s-ui/domain'

export default class GigyaEventAuthenticationValueObject extends ValueObject {
  constructor({eventName, screenSet, formData = {}, errorCode}) {
    super({eventName, screenSet, formData, errorCode})
  }

  getErrorCode() {
    return this._errorCode
  }

  getEventName() {
    return this._eventName
  }

  getFormData() {
    return this._formData
  }

  getScreenSet() {
    return this._screenSet
  }

  isValidationEvent() {
    return this._eventName === 'beforeValidation'
  }

  isAfterSubmit() {
    return this._eventName === 'afterSubmit'
  }

  hasEmail() {
    return !!(this._formData.email || this._formData.loginID)
  }

  isStatusSuccess() {
    return Boolean(this._formData.status === 'OK')
  }

  onRegisterScreen() {
    return this._screenSet === 'register-mt'
  }

  onLoginScreen() {
    return this._screenSet === 'login-mt'
  }

  onResetPasswordScreen() {
    return this._screenSet === 'reset-password-mt'
  }

  getUID() {
    return this._formData.UID
  }
}
